// extracted by mini-css-extract-plugin
module.exports = {"precinct-diff-table":"differential-list-precincts_precinct-diff-table__1-XZo"};